// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import {
  FETCH_AGENCIES_REQUEST,
  DELETE_AGENCIES_REQUEST,
  FETCH_AGENCY_REQUEST,
  UPDATE_AGENCIES_REQUEST,
  FETCH_AGENCIES_RELEASE_REQUEST,
  OPEN_EDIT_PAGE_AGENCY,
} from './actionTypes';
import {
  fetchAgenciesSuccess,
  fetchAgenciesFailure,
  deleteAgencySuccess,
  deleteAgencyFailure,
  fetchAgencySuccess,
  fetchAgencyFailure,
  updateAgencySuccess,
  updateAgencyFailure,
  fetchAgenciesReleaseSuccess,
  fetchAgenciesReleaseFailure,
} from './actions';
import { deleteAgency, getAllAgencies, getAgency, updateAgency } from '../../helpers/backend_helper';
import { openEditPageAgencySuccess } from '../actions';
import { reduxSerializedError } from '../../utils/utils';

function* fetchAgenciesSaga() {
  try {
    const response = yield call(getAllAgencies);
    yield put(fetchAgenciesSuccess(response));
  } catch (error) {
    yield put(fetchAgenciesFailure(reduxSerializedError(error)));
  }
}

function* fetchAgenciesReleaseSaga() {
  try {
    const response = yield call(getAllAgenciesRelease);
    yield put(fetchAgenciesReleaseSuccess(response));
  } catch (error) {
    yield put(fetchAgenciesReleaseFailure(reduxSerializedError(error)));
  }
}

function* fetchAgencySaga({ payload }) {
  try {
    const response = yield call(getAgency, payload);
    yield put(fetchAgencySuccess(response));
  } catch (error) {
    yield put(fetchAgencyFailure(reduxSerializedError(error)));
  }
}

function* deleteAgenciesSaga({ payload }) {
  try {
    yield call(deleteAgency, payload);
    yield put(deleteAgencySuccess(payload));
    yield call(fetchAgenciesSaga); // Refresh the agencies list
  } catch (error) {
    yield put(deleteAgencyFailure(reduxSerializedError(error)));
  }
}

function* updateAgencySaga({ payload }) {
  const { agency, navigate } = payload;
  try {
    yield call(updateAgency, agency);
    yield put(updateAgencySuccess());
    navigate('/agencies');
    yield call(fetchAgenciesSaga); // Refresh the agencies list
  } catch (error) {
    yield put(updateAgencyFailure(reduxSerializedError(error)));
  }
}

function* openEditPageAgencySaga({ payload }) {
  const { id, navigate } = payload;
  try {
    navigate(`/agencies/${id}`);
    yield put(openEditPageAgencySuccess());
  } catch (error) {
    console.error('Navigation error:', error);
  }
}

export default function* rootSaga() {
  yield takeEvery(FETCH_AGENCIES_REQUEST, fetchAgenciesSaga);
  yield takeEvery(FETCH_AGENCIES_RELEASE_REQUEST, fetchAgenciesReleaseSaga);
  yield takeEvery(FETCH_AGENCY_REQUEST, fetchAgencySaga);
  yield takeEvery(UPDATE_AGENCIES_REQUEST, updateAgencySaga);
  yield takeEvery(DELETE_AGENCIES_REQUEST, deleteAgenciesSaga);
  yield takeEvery(OPEN_EDIT_PAGE_AGENCY, openEditPageAgencySaga);
}
